import { action, computed, observable } from "mobx";
import Autobind from "autobind-decorator";

@Autobind
class SeriesMetadataModel {
  /**
   * Image Information
   */

  @observable
  _modality = "";

  @observable
  _numberOfFrames = 0;

  /**
   * Series Information
   */
  @observable
  _seriesID = "";

  @observable
  _seriesDescription = "";

  @observable
  _seriesInstanceUID = "";

  @observable
  _seriesNumber = "";

  /**
   * Study Information
   */
  @observable
  _studyDate = "";

  @observable
  _studyDescription = "";

  @observable
  _studyTime = "";

  @action
  setSeriesMetadata(
    modality: string,
    numberOfFrames: number,
    seriesID: string,
    seriesDescription: string,
    seriesInstanceUID: string,
    seriesNumber: string,
    studyDate: string,
    studyDescription: string,
    studyTime: string
  ) {
    if (this._modality !== modality) {
      this._modality = modality;
    }

    if (this._numberOfFrames !== numberOfFrames) {
      this._numberOfFrames = numberOfFrames;
    }

    if (this._seriesID !== seriesID) {
      this._seriesID = seriesID;
    }

    if (this._seriesDescription !== seriesDescription) {
      this._seriesDescription = seriesDescription;
    }

    if (this._seriesInstanceUID !== seriesInstanceUID) {
      this._seriesInstanceUID = seriesInstanceUID;
    }

    if (this._seriesNumber !== seriesNumber) {
      this._seriesNumber = seriesNumber;
    }

    if (this._studyDate !== studyDate) {
      this._studyDate = studyDate;
    }

    if (this._studyDescription !== studyDescription) {
      this._studyDescription = studyDescription;
    }

    if (this._studyTime !== studyTime) {
      this._studyTime = studyTime;
    }
  }

  get modality() {
    return this._modality;
  }
  set modality(modality) {
    this._modality = modality;
  }

  get numberOfFrames() {
    return this._numberOfFrames;
  }
  set numberOfFrames(numberOfFrames) {
    this._numberOfFrames = numberOfFrames;
  }

  get seriesID() {
    return this._seriesID;
  }
  set seriesID(seriesID) {
    this._seriesID = seriesID;
  }

  get seriesDescription() {
    return this._seriesDescription;
  }
  set seriesDescription(seriesDescription) {
    this._seriesDescription = seriesDescription;
  }

  get seriesInstanceUID() {
    return this._seriesInstanceUID;
  }
  set seriesInstanceUID(seriesInstanceUID) {
    this._seriesInstanceUID = seriesInstanceUID;
  }

  get seriesNumber() {
    return this._seriesNumber;
  }
  set seriesNumber(seriesNumber) {
    this._seriesNumber = seriesNumber;
  }

  get studyDate() {
    return this._studyDate;
  }
  set studyDate(studyDate) {
    this._studyDate = studyDate;
  }

  get studyDescription() {
    return this._studyDescription;
  }
  set studyDescription(studyDescription) {
    this._studyDescription = studyDescription;
  }

  get studyTime() {
    return this._studyTime;
  }
  set studyTime(studyTime) {
    this._studyTime = studyTime;
  }
}

export default SeriesMetadataModel;
